module.exports = __webpack_public_path__ + "img/ren.d4dedf6c.jpg";